import { makeStyles, DefaultTheme } from '@material-ui/styles';

const useStyles = makeStyles<DefaultTheme>({
    grid_root: {
        flexDirection: 'column',
    },
});

export default useStyles;